module.exports = __webpack_public_path__ + "static/media/xenon-full.71298017.png";